export default {
      id: "icon-devis-usage",
      viewBox: "0 0 32 32",
      url: "../icon/" + "icons.svg#icon-devis-usage",
      toString: function () {
        return this.url;
      }
    }